module.exports = __webpack_public_path__ + "static/media/moon.d0869567.svg";